import { render, staticRenderFns } from "./UserCredentials.vue?vue&type=template&id=b539be4a&scoped=true&"
import script from "./UserCredentials.vue?vue&type=script&lang=js&"
export * from "./UserCredentials.vue?vue&type=script&lang=js&"
import style0 from "./UserCredentials.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserCredentials.vue?vue&type=style&index=1&lang=css&"
import style2 from "./UserCredentials.vue?vue&type=style&index=2&id=b539be4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b539be4a",
  null
  
)

export default component.exports